import React from 'react'

import { PayPalScriptProvider, PayPalMessages } from '@paypal/react-paypal-js'

function PayPalBanner({ clientId, ...props }) {
	return <PayPalScriptProvider
		options={{
			'client-id': clientId,
			components: 'messages',
		}}
	>
		<PayPalMessages
			{...props}
		/>
	</PayPalScriptProvider>
}

export default PayPalBanner
